module.exports = __webpack_public_path__ + "img/arrow_up.6318f24a.svg";